import { LocalizedLink } from "@/i18n/language";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { img } from "@/lib/images";

const categories = [
  {
    id: "tour-info",
    titleKey: "tour_category_info_title",
    descKey: "tour_category_info_desc",
    img: img("activities/activities-tourinfo-01.jpg"),
    to: "/tour-info",
  },
  {
    id: "day-trips",
    titleKey: "tour_category_daytrips_title",
    descKey: "tour_category_daytrips_desc",
    img: img("activities/activities-daytrips-01.jpg"),
    to: "/day-trips",
  },
  {
    id: "multi-day",
    titleKey: "tour_category_multiday_title",
    descKey: "tour_category_multiday_desc",
    img: img("activities/activities-multidaytours-01.jpg"),
    to: "/multi-day-tours",
  },
  {
    id: "adventure",
    titleKey: "tour_category_adventure_title",
    descKey: "tour_category_adventure_desc",
    img: img("activities/activities-adventure-01.jpg"),
    to: "/adventure-tours",
  },
];

export default function ActivitiesPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Navbar />
      <main>
        <PageHeader
          eyebrow={t("activities_eyebrow")}
          title={t("activities_title")}
          subtitle={t("activities_intro")}
          image={img("activities/header-activities-01.jpg")}
          imageAlt="Tours and activities in Bali"
        />

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center max-w-3xl mx-auto mb-10">
              <div className="eyebrow-brand text-xs uppercase tracking-[0.35em] mb-3">
                — {t("tour_categories_eyebrow")} —
              </div>
              <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-[1.12] tracking-tight">
                {t("tour_categories_title")}
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {categories.map((cat) => (
                <div
                  key={cat.id}
                  className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-600 transition-all"
                >
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <img
                      src={cat.img}
                      alt={t(cat.titleKey)}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mb-2">
                      {t(cat.titleKey)}
                    </h3>
                    <div className="w-10 h-0.5 bg-accent-500 mb-4"></div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                      {t(cat.descKey)}
                    </p>
                    <LocalizedLink
                      to={cat.to}
                      className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-100 text-background-50 hover:text-foreground-950 text-sm font-medium px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors"
                    >
                      {t("read_more")}
                      <i className="ri-arrow-right-line"></i>
                    </LocalizedLink>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}